module.exports = __webpack_public_path__ + "media/tang_5.f92a04ac.mp4";